import { useRecoilValue } from "recoil";

import mainStore, { storeSetEachWay } from "src/stores/main";
import { useTranslation } from "src/hooks/translation";
import ToggleSwitch from "src/common/components/toggleSwitch";

import "./style.scss";

const EachWayToggle = () => {
	const t = useTranslation();
	const { isEachWay } = useRecoilValue(mainStore);

	const toggleEachWay = () => storeSetEachWay(!isEachWay);

	return (
		<div className="B-betslip-eachway-toggle">
			<div className={`B-content ${isEachWay ? "B-active" : ""}`}>
				<span className="B-eachway">{t("Each way")}</span>
				<ToggleSwitch onChange={toggleEachWay} checked={isEachWay} />
			</div>
		</div>
	);
};

export default EachWayToggle;
